import _ from 'lodash';
import React from 'react';
import Switch from 'react-switch';
import moment from 'moment';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';

// import EditImage from 'common/components/edit-image';
import EditImage from 'client/shared/components/edit-image/edit-image';
import ConfirmButton from 'common/components/confirm-button';
@inject('artistStore', 'userStore')
@observer
class ArtistInfoHeader extends React.Component {
	constructor (props) {
		super(props);
		const { _id } = this.props.artistStore.data.artist.toPOJO();

	}

	render () {

		const { artistStore, userStore } = this.props;
		const artist = artistStore.data.artist.toPOJO();
		const { _id, userID, name, createdAt } = artist;
		const { totalScore, tier } = artistStore;
		const joinedDate = moment(createdAt).format('MM/DD/YY');

        return (
			<div className="grid-x grid-padding-x grid-padding-y align-middle">
				<div className="cell shrink">
					<EditImage
						store={ userStore }
						imgSrc={ artistStore.getArtistImage() }
						handleImageCrop={ this.handleImageCrop } />
				</div>

				<div className="cell auto">
					<div className="grid-x grid-padding-x">
						<div className="cell small-1">
							<ConfirmButton
								warningText={ `Really delete ${artistStore.get('artist.name')}?` }
								onConfirmClick={ this.onConfirmClick }
								label={ <span className="fal fa-trash"></span> }
							>
							</ConfirmButton>
						</div>
						<div className="cell small-11">
							<h2 data-ta="artistInfoHeader">{ name }</h2>
						</div>
						<div className="cell small-12">
							<div className="admin-artist-info">
								<NavLink to={ `/submissions/artist/${_id}` }>
									Artist Score: { totalScore } | { tier }
								</NavLink>
							</div>
						</div>
						<div className="cell small-12 grid-x">
							<div className="cell small-2">Exclusive Artist</div>
							<div className="cell small-6">
								<Switch checked={artist.isExclusive} height={18} width={38} onColor="#6f3c8a" checkedIcon={false} onChange={ (e) => this.setExclusive(e, artist)} />
							</div>
						</div>
						<div className="cell small-12">
							<div>Joined On: { joinedDate } | Lifetime Subscriptions 0 | YTD Subscriptions 0 | MTD Subscriptions 0</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	async setExclusive (evt, artist) {
		console.log(evt);
		console.log(artist);
		this.props.artistStore.set({key: 'isExclusive', value: evt, silent: false});
		await this.props.artistStore.saveArtist();
	}
	@autobind
	handleImageCrop (cropResult) {
		this.props.userStore.setProfileImageData(cropResult);
	}
	@autobind
	async onConfirmClick () {
		const { artistStore } = this.props;
		try {

			await artistStore.deleteItem(artistStore.data.artist.toPOJO());
			window.location.hash = '#/manage-artists/ACTIVE/TIER_1';
		} catch (err) {

			console.error('[ERROR DELETING ARTIST]', err);
		}
	}
}

export default ArtistInfoHeader;
